import { Navigate, Outlet } from "react-router";
import { useAuth } from "../providers/AuthenticationProvider";
import { useEffect } from "react";
import Loading from "../components/Loading";

const OnlyTrader = () => {
	const { user, traderProfile } = useAuth();
	if (user != null && user.uid != "" && traderProfile != null) {
		return <Outlet />;
	}
	return (
		<>
			<h1>Unauthorized</h1>
		</>
	);
};

export default OnlyTrader;
